import { InlineAlert } from '@tkww/orion-web-ds-feedback';
import React from 'react';

interface MinimumSpendAlertProps {
	originalEstimate: string;
	minimumSpend: string;
	className?: string;
}

export const MinimumSpendAlert = ({
	originalEstimate,
	minimumSpend,
	className,
}: MinimumSpendAlertProps) => (
	<InlineAlert styleType="warning" className={className}>
		{`Your original estimated total of ${originalEstimate} has been adjusted to meet the venue\u2019s required minimum spend of ${minimumSpend}.`}
	</InlineAlert>
);
